<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-container fluid>
            <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
                <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
                <v-btn dark text @click="snackbar = false">Close</v-btn>
            </v-snackbar>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-card class="box">
                <v-toolbar flat dense class="toolbar">
                    <v-toolbar-title>Teacher Book Review</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-row justify="center" dense>
                    <v-col cols="12" sm="3">
                        <p>
                            <b>Academic Year</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                        </p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list"
                            item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                            hint="Please Select Academic Year" @change="getStandard()" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" v-if="ay && standard_list != ''">
                        <p>
                            <b>Standard</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                        </p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="standard" :items="standard_list"
                            item-text="standard" item-value="id" label="Standard" outlined persistent-hint
                            hint="Please Select Standard" @change="getSubjects()" />
                    </v-col>
                    <v-col cols="12" sm="4" md="4" v-if="subject_list != '' && this.standard != ''">
                        <p>
                            <b>Subject</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                        </p>
                        <v-autocomplete color="#0F2027" dense rounded required v-model="subject" :items="subject_list"
                            item-text="name" item-value="id" label="Subject" outlined persistent-hint
                            hint="Please Select Subject" />
                    </v-col>

                    <v-col cols="12" sm="1" md="1" v-if="subject">
                        <p>
                            <v-icon color="error"></v-icon>
                        </p>
                        <v-btn class="mt-4" small color="warning" @click="fetch()">Fetch</v-btn>
                    </v-col>
                </v-row>
            </v-card>

            <v-row justify="center" v-if="review_criteria_details.length > 0" dense>
                <v-btn small color="warning" @click="show_card()">Add Book Review</v-btn>
            </v-row>

            <template v-if="add_book_review && review_criteria_details != ''">
                <v-card class="box" v-if="review_criteria_details.length > 0">
                    <v-toolbar flat dense class="toolbar">
                        <v-toolbar-title>Teacher Book Review</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <br />
                    <v-simple-table class="simple-table">
                        <thead>
                            <th>Academic Year</th>
                            <th>Standard</th>
                            <th>Subject</th>
                        </thead>
                        <tbody>
                            <tr>
                                <td>{{ ay_display }}</td>
                                <td>{{ standard_display }}</td>
                                <td>{{ subject_display }}</td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <br />
                    <form id="review-form" class="review-form" @submit.prevent="submitForm">
                        <v-row justify="center" dense>
                            <!-- Book Name -->
                            <v-col cols="12" sm="8">
                                <p class="mb-1">
                                    <b>Name Of The Book</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                                </p>
                                <input type="text" required v-model="bookDetails.name" class="input-text" round dense />
                            </v-col>

                            <!-- Publisher -->
                            <v-col cols="12" sm="8">
                                <p class="mb-1">
                                    <b>Publisher</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                                </p>
                                <v-autocomplete dense v-model="bookDetails.publisher" required item-text="name"
                                    item-value="id" :items="publisher_list" outlined persistent-hint></v-autocomplete>
                            </v-col>

                            <!-- Author -->
                            <v-col cols="12" sm="8">
                                <p class="mb-1" style="margin-top: -19px;">
                                    <b>Author</b>
                                </p>
                                <input type="text" v-model="bookDetails.author" class="input-text" round dense />
                            </v-col>
                            <!-- Price -->
                            <v-col cols="12" sm="8">
                                <p class="mb-1">
                                    <b>Price</b><v-icon class="pl-1 pb-3" color="error">*</v-icon>
                                </p>
                                <input type="number" step="any" required v-model="bookDetails.price" class="input-text"
                                    round dense />
                            </v-col>

                            <!-- Dynamically Generated Criteria List -->
                            <v-col cols="12" sm="8" v-for="(item) in review_criteria_details" :key="item.id">
                                <p class="mb-1">
                                    <b>{{ item.name }}</b>
                                    <!-- <v-icon class="pl-1 pb-3" color="error">*</v-icon> -->
                                </p>

                                <input v-if="item.bookreviewcriteriatype.toLowerCase() === 'string'" type="textarea"
                                    v-model="item.value" class="input-text" round dense />
                                <input v-if="item.bookreviewcriteriatype.toLowerCase() === 'double'" step="any"
                                    type="number" v-model="item.value" class="input-text" round dense />
                                <input v-if="item.bookreviewcriteriatype.toLowerCase() === 'integer'" type="number"
                                    v-model="item.value" class="input-text" round dense />
                                <v-radio-group v-if="item.bookreviewcriteriatype.toLowerCase() === 'boolean'"
                                    v-model="item.value" row>
                                    <v-radio label="Yes" :value="true"></v-radio>
                                    <v-radio label="No" :value="false"></v-radio>
                                </v-radio-group>

                                <v-autocomplete v-if="item.bookreviewcriteriatype.toLowerCase() === 'select'" dense
                                    v-model="item.value" :items="item.options" item-text="text" item-value="value"
                                    outlined persistent-hint>
                                </v-autocomplete>
                            </v-col>
                            <!-- Is Recommended -->
                            <v-col cols="12" sm="8">
                                <p class="mb-1">
                                    <b>Is Recommended ?</b>
                                </p>
                                <v-radio-group v-model="bookDetails.isrecommended" row>
                                    <v-radio label="Yes" :value="true"></v-radio>
                                    <v-radio label="No" :value="false"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <!-- Remark -->
                            <v-col cols="12" sm="8">
                                <p class="mb-1">
                                    <b>Remark</b>
                                </p>
                                <input type="textarea" v-model="bookDetails.remark" class="input-text" round dense />
                            </v-col>
                            <!-- Book Cover -->
                            <v-col cols="12" sm="8">
                                <p class="mb-3 mt-3">
                                    <b>Upload Book Front Cover</b>
                                </p>
                                <v-file-input prepend-icon="mdi-file" label="Upload Book Front Cover" show-size flat
                                    rounded outlined dense v-model="bookDetails.front_cover"></v-file-input>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-btn type="submit" :loading="loader" :disabled="loader" small
                                color="warning">Submit</v-btn>
                        </v-row>
                    </form>

                </v-card>
            </template>
            <v-row v-if="books.length > 0" dense>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="2" md="2" class="ml-2" align="center">
                    <v-btn rounded color="success" outlined
                        @click="fnExcelReport('my-table-id', 'Teacher Book Review')"><v-icon
                            color="success">mdi-export</v-icon>Export</v-btn>
                </v-col>
            </v-row>
            <v-card v-if="books.length > 0" class="box">
                <template>
                    <div class="table-container">
                        <table class="styled-table" id="my-table-id">
                            <thead>
                                <tr>
                                    <th>S.No</th>
                                    <th>Criteria</th>
                                    <th v-for="book in books" :key="book.book_id">{{ book.publisher_name }} <button
                                            v-if="book.publisher_name !== null"
                                            @click="selecteddeleteBook(book.book_id, book.reviews)" class="delete-btn">
                                            <v-icon class="fa fa-trash" color="error">mdi-trash-can</v-icon>
                                        </button></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Name of the Text Book</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        {{ book.name || 'N/A' }}
                                        <button @click="editBookName(book.book_id, book.name)" class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Publisher</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        {{ book.publisher_name || 'N/A' }}
                                        <button @click="editBookPublisher(book.book_id, book.publisher_name)"
                                            class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Author</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        {{ book.author || 'N/A' }}
                                        <button @click="editBookAuthor(book.book_id, book.author)" class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Front Cover</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        <button @click="viewCover(book.front_cover_file)" class="view-btn">
                                            <v-icon class="fa fa-eye mr-2">mdi-eye</v-icon>
                                        </button>
                                        <button @click="editBookCover(book.book_id, book.front_cover_file)"
                                            class="edit-btn">
                                            <v-icon class="fa fa-edit mr-2"
                                                color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Is Currently Used?</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        <v-icon v-if="book.iscurrentlyused" color="success"
                                            class="fa fa-check">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else class="fa fa-times"
                                            color="error">mdi-close-circle-outline</v-icon>
                                        <button @click="editUsage(book.book_id, book.iscurrentlyused)" class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr v-for="(criteria, index) in review_criteria_details" :key="criteria.id">
                                    <td>{{ index + 1 }}</td>
                                    <td class="text-left">
                                        <div>{{ criteria.name || 'N/A' }}</div>
                                    </td>
                                    <td v-for="book in books" :key="book.book_id">
                                        <div v-if="getReviewValue(book.reviews, criteria.id)">
                                            {{ getReviewValue(book.reviews, criteria.id) }}
                                        </div>
                                        <div v-else>
                                            N/A
                                        </div>
                                        <button
                                            @click="editBook(getReviewId(book.reviews, criteria.id), getReviewValue(book.reviews, criteria.id), criteria.id, criteria.bookreviewcriteriatype, criteria.name, book.book_id)"
                                            class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                        <button v-if="getReviewValue(book.reviews, criteria.id) !== null"
                                            @click="deleteBook(getReviewId(book.reviews, criteria.id))"
                                            class="delete-btn">
                                            <v-icon class="fa fa-trash" color="error">mdi-trash-can</v-icon>
                                        </button>
                                    </td>
                                </tr>

                                <tr>
                                    <td></td>
                                    <td class="text-left">Price of Book</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        {{ book.price || 'N/A' }}
                                        <button @click="editBookPrice(book.book_id, book.price)" class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Is Recommended ?</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        <v-icon v-if="book.isrecommended" color="success"
                                            class="fa fa-check">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else class="fa fa-times"
                                            color="error">mdi-close-circle-outline</v-icon>
                                        <button @click="editRecommandation(book.book_id, book.isrecommended)"
                                            class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Remark</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        {{ book.remark || 'N/A' }}
                                        <button @click="editBookRemark(book.book_id, book.remark)" class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td class="text-left">Review Date</td>
                                    <td v-for="book in books" :key="book.book_id">
                                        {{ (book.review_date) || 'N/A' }}
                                        <button @click="editReviewDate(book.book_id, book.review_date_edit)"
                                            class="edit-btn">
                                            <v-icon class="fa fa-edit" color="indigo">mdi-pencil-box-outline</v-icon>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </template>
            </v-card>
            <v-dialog v-model="CommonEditDialog" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit Book Review Criteria
                    </v-card-title>
                    <v-card-text>
                        <div v-if="this.bookreviewcriteriatype.toLowerCase() === 'string'">
                            <b class="ml-2">{{ this.bookreviewcriteria }}</b>
                            <v-text-field class="pt-4" v-model="currentBookReviewCriteria"
                                label="Book Review Criteria Value" outlined></v-text-field>
                        </div>
                        <div v-if="this.bookreviewcriteriatype.toLowerCase() === 'double'">
                            <b class="ml-2">{{ this.bookreviewcriteria }}</b>
                            <input step="any" type="number" v-model="currentBookReviewCriteria" class="input-text"
                                style="margin-top: 10px;" round dense />
                        </div>
                        <div v-if="this.bookreviewcriteriatype.toLowerCase() === 'integer'">
                            <b class="ml-2">{{ this.bookreviewcriteria }}</b>
                            <input type="number" step="1" @input="sanitizeInput" v-model="currentBookReviewCriteria"
                                class="input-text" style="margin-top: 10px;" round dense />
                        </div>
                        <div v-if="this.bookreviewcriteriatype.toLowerCase() === 'boolean'">
                            <b>{{ this.bookreviewcriteria }}</b>
                            <v-radio-group v-model="currentBookReviewCriteria" row>
                                <v-radio label="Yes" :value="'true'"></v-radio>
                                <v-radio label="No" :value="'false'"></v-radio>
                            </v-radio-group>
                        </div>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="CommonEditDialog = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentBookReviewCriteria, 'review', criteria_id, bookId)">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="NameEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit name of the text book
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="currentBookName" label="Name of the Text Book" outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="NameEdit = false;">Cancel</v-btn>
                        <v-btn color="primary" @click="saveBook(currentBookId, currentBookName, 'name')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="PublisherEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit publisher of the text book
                    </v-card-title>
                    <v-card-text>
                        <v-autocomplete dense v-model="currentBookPublisher" required item-text="name" item-value="id"
                            :items="publisher_list" outlined persistent-hint></v-autocomplete>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="PublisherEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentBookPublisher, 'publisher')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="AuthorEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit author of the text book
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="currentBookAuthor" label="Author of the Text Book"
                            outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="AuthorEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentBookAuthor, 'author')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="CoverEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit cover of the text book
                    </v-card-title>
                    <v-card-text>
                        <v-file-input prepend-icon="mdi-file" label="Upload Book Front Cover" show-size flat rounded
                            outlined dense v-model="currentBookCover"></v-file-input>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="CoverEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="submitFile(currentBookId, currentBookCover, 'front_cover')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="PriceEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit price of the text book
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="currentBookPrice" label="Price of the Text Book" outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="PriceEdit = false;">Cancel</v-btn>
                        <v-btn color="primary" @click="saveBook(currentBookId, currentBookPrice, 'price')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="RemarkEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit remark
                    </v-card-title>
                    <v-card-text>
                        <v-text-field v-model="currentBookRemark" label="Remark" outlined></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="RemarkEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentBookRemark, 'remark')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="DateEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Edit review date
                    </v-card-title>
                    <v-card-text>
                        <input type="date" v-model="currentReviewDate" id="date" name="date" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="DateEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentReviewDate, 'review_date')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="RecommondationEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Is Recommonded ?
                    </v-card-title>
                    <v-card-text>
                        <v-radio-group v-model="currentRecommondationStatus" row>
                            <v-radio label="Yes" :value="true"></v-radio>
                            <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="RecommondationEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentRecommondationStatus, 'recommondation')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="CurrentUseEdit" max-width="500">
                <v-card>
                    <v-card-title>
                        Is Currently Used ?
                    </v-card-title>
                    <v-card-text>
                        <v-radio-group v-model="currentUseStatus" row>
                            <v-radio label="Yes" :value="true"></v-radio>
                            <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" @click="CurrentUseEdit = false;">Cancel</v-btn>
                        <v-btn color="primary"
                            @click="saveBook(currentBookId, currentUseStatus, 'iscurrentlyused')">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>
    </div> <!-- /. root div -->
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        books: [], add_book_review: false,
        bookDetails: {},
        loader: false,
        snackbar_msg: "",
        color: "",
        // extraBreadcrumbItems: [


        // ],
        // breadcrumbClass: "breadcrumb-style1",
        snackbar: false,
        overlay: false,
        ay_list: [],
        ay: "",
        standard_list: [],
        standard: "",
        subject_list: [],
        subject: "",
        publisher_list: [],
        review_criteria_details: [],
        ay_display: "",
        standard_display: "",
        subject_display: "",
        // show: true,
        basepath: null,
        allCriteriaFilled: false,
        CommonEditDialog: false,
        NameEdit: false,
        PublisherEdit: false,
        AuthorEdit: false,
        CoverEdit: false,
        PriceEdit: false,
        RemarkEdit: false,
        DateEdit: false,
        RecommondationEdit: false,
        CurrentUseEdit: false,
        currentBookId: null,
        currentBookReviewCriteria: "",
        currentBookName: "",
        currentBookPublisher: "",
        currentBookAuthor: "",
        currentBookCover: null,
        currentBookPrice: "",
        currentBookRemark: "",
        currentReviewDate: null,
        currentRecommondationStatus: false,
        criteria_id: null,
        currentUseStatus: false,
        reviewsList: [],
        bookreviewcriteriatype: "",
        bookreviewcriteria: "",
        bookId: null,
    }),
    methods: {
        sanitizeInput(event) {
            const value = event.target.value;
            const sanitizedValue = value.replace(/[^0-9]/g, '');
            this.currentBookReviewCriteria = sanitizedValue;
            event.target.value = sanitizedValue;
        },
        getReviewValue(reviews, criteriaId) {
            const review = reviews.find(r => r.bookreviewcriteria_id === criteriaId);
            return review ? review.bookreviewcriteria_value : null;
        },
        getReviewId(reviews, criteriaId) {
            const review = reviews.find(r => r.bookreviewcriteria_id === criteriaId);
            return review ? review.id : null;
        },
        formatDate(date) {
            if (!date) return 'N/A';
            const parsedDate = new Date(date);
            const day = String(parsedDate.getDate()).padStart(2, '0');
            const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
            const year = parsedDate.getFullYear();
            const hours = String(parsedDate.getHours()).padStart(2, '0');
            const minutes = String(parsedDate.getMinutes()).padStart(2, '0');

            return `${day}-${month}-${year} ${hours}:${minutes}`;
        },
        viewCover(coverPath) {
            window.open(this.basepath + coverPath, "_blank");
        },
        submitForm: function (e) {
            if (!this.bookDetails.name || !this.bookDetails.publisher) {
                this.showSnackbar("error", "Book Name and Publisher are required.");
                return;
            }

            if (this.bookDetails.isrecommended === undefined || this.bookDetails.isrecommended === null) {
                this.bookDetails.isrecommended = false; // Default to false
            }

            var formData = new FormData();
            formData.append("name", this.bookDetails.name);
            formData.append("publisher", this.bookDetails.publisher);
            formData.append("author", this.bookDetails.author);
            formData.append("price", this.bookDetails.price);
            formData.append("remark", this.bookDetails.remark);
            formData.append("isrecommended", this.bookDetails.isrecommended);
            formData.append("coi_id", this.subject);

            if (this.bookDetails.front_cover) {
                formData.append("front_cover", this.bookDetails.front_cover);
            }

            const criteria_ids = [];
            const criteria_values = [];

            // ✅ Ensure only valid criteria are sent
            this.review_criteria_details.forEach((item) => {
                if (item.id && item.value !== undefined && item.value !== null && item.value !== '') {
                    criteria_ids.push(item.id);
                    criteria_values.push(item.value);
                }
            });

            // if (criteria_ids.length === 0) {
            //     this.showSnackbar("error", "Please complete at least one valid review criteria.");
            //     return;
            // }

            formData.append("criteria_id", JSON.stringify(criteria_ids));
            formData.append("criteria_value", JSON.stringify(criteria_values));

            this.loader = true;
            axios
                .post("BookReview/saveBookReview", formData)
                .then((res) => {
                    if (res.data.flag === "YES") {
                        this.showSnackbar("#4CAF50", "Review Submitted Successfully...");
                        this.clearData();
                    } else {
                        this.showSnackbar("error", res.data.snackbar || "Something went wrong...");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.showSnackbar("error", "Something went wrong...");
                })
                .finally(() => {
                    this.loader = false;
                });
        },

        // submitForm: function (e) {

        //     const allCriteriaFilled = this.review_criteria_details.every(item => {
        //         console.log(`Item: ${JSON.stringify(item)}, Value: ${item.value}`);
        //         return item.value !== undefined && item.value !== null && item.value !== '';
        //     });

        //     // alert(allCriteriaFilled);

        //     if (!allCriteriaFilled) {
        //         this.showSnackbar("error", "Please complete all review criteria");
        //         return;
        //     }
        //     var formData = new FormData();
        //     formData.append("name", this.bookDetails.name);
        //     formData.append("publisher", this.bookDetails.publisher);
        //     formData.append("author", this.bookDetails.author);
        //     formData.append("price", this.bookDetails.price);
        //     formData.append("remark", this.bookDetails.remark);
        //     formData.append("isrecommended", this.bookDetails.isrecommended);
        //     formData.append("coi_id", this.subject,);

        //     if (this.bookDetails.front_cover) {
        //         formData.append("front_cover", this.bookDetails.front_cover);
        //     }

        //     const criteria_ids = [];
        //     const criteria_values = [];

        //     this.review_criteria_details.forEach((item) => {
        //         criteria_ids.push(item.value);
        //     });
        //     this.review_criteria_details.forEach((item) => {
        //         criteria_values.push(item.value);
        //     });

        //     formData.append("criteria_id", JSON.stringify(criteria_ids));
        //     formData.append("criteria_value", JSON.stringify(criteria_values));

        //     this.loader = true;
        //     axios
        //         .post("BookReview/saveBookReview", formData)
        //         .then((res) => {
        //             if (res.data.flag == "YES") {
        //                 this.showSnackbar("#4CAF50", "Review Submitted Successfully...");
        //                 this.clearData();
        //             } else if (res.data.flag == "No") {
        //                 this.showSnackbar("error", res.data.snackbar);
        //                 this.clearData();
        //             }
        //             else {
        //                 this.showSnackbar("error", "Something went wrong...")
        //                 this.clearData();
        //             }
        //         })
        //         .catch((error) => {
        //             console.log(error);
        //         })
        //         .finally(() => {
        //             this.loader = false;
        //         });
        // },
        clearData() {
            this.bookDetails = {
                name: "",
                publisher: "",
                author: "",
                price: "",
                remark: "",

                front_cover: null
            }
            this.review_criteria_details.forEach(item => {
                item.value = null;
            });
        },
        deleteBook(id) {
            // console.log("id"+ id);
            if (!confirm("Are You Sure You Want To Delete ...?")) return;
            const data = {
                review_id: id,
                coi_id: this.subject,
            }
            axios
                .post("BookReview/deleteBookReview", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.showSnackbar("success", "Deleted successfully");
                        this.books = res.data.book_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
                })
                .finally(() => {
                });
        },

        selecteddeleteBook(id, review_id) {

            if (!confirm("Are You Sure You Want To Delete This Book...?")) return;
            const data = {

                book_id: id,
                review_id: review_id,
                coi_id: this.subject,

            }
            axios
                .post("BookReview/selecteddeleteBook", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.showSnackbar("success", "Deleted successfully");
                        this.books = res.data.book_list;
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
                })
                .finally(() => {
                });
        },
        editBook(id, sel_criteria, criteria_id, type, criteria, bookId) {
            this.CommonEditDialog = true;
            this.currentBookId = id;
            this.currentBookReviewCriteria = sel_criteria;
            this.criteria_id = criteria_id;
            this.bookreviewcriteriatype = type;
            this.bookreviewcriteria = criteria;
            this.bookId = bookId;
        },
        editBookName(id, name) {
            this.NameEdit = true;
            this.currentBookId = id;
            this.currentBookName = name;
        },
        editBookPublisher(id, pb) {
            this.PublisherEdit = true;
            this.currentBookId = id;
            this.currentBookPublisher = pb;
        },
        editBookAuthor(id, auth) {
            this.AuthorEdit = true;
            this.currentBookId = id;
            this.currentBookAuthor = auth;
        },
        editBookCover(id, file) {
            // console.log("file path" + file);
            this.CoverEdit = true;
            this.currentBookId = id;
            this.currentBookCover = null;
            // console.log(this.currentBookCover);
        },
        editBookPrice(id, price) {
            this.PriceEdit = true;
            this.currentBookId = id;
            this.currentBookPrice = price;
        },
        editReviewDate(id, date) {
            this.DateEdit = true;
            this.currentBookId = id;
            this.currentReviewDate = date;
        },
        editBookRemark(id, remark) {
            this.RemarkEdit = true;
            this.currentBookId = id;
            this.currentBookRemark = remark;
        },
        editRecommandation(id, rcmd) {
            this.RecommondationEdit = true;
            this.currentBookId = id;
            this.currentRecommondationStatus = rcmd;
        },
        editUsage(id, use) {
            this.CurrentUseEdit = true;
            this.currentBookId = id;
            this.currentUseStatus = use;
        },
        saveBook(id, value, type, criteria_id, book_id) {
            // console.log("value "+ value);        
            if (type === 'review' && this.currentBookReviewCriteria === '') {
                this.showSnackbar("error", "Please enter book review criteria value");
                return;
            } else if (type === 'name' && this.currentBookName === '') {
                this.showSnackbar("error", "Please enter the book name");
                return;
            } else if (type === 'publisher' && this.currentBookPublisher === '') {
                this.showSnackbar("error", "Please enter the publisher's name");
                return;
            } else if (type === 'author' && this.currentBookAuthor === '') {
                this.showSnackbar("error", "Please enter the author's name");
                return;
            } else if (type === 'price' && this.currentBookPrice === '') {
                this.showSnackbar("error", "Please enter the book price");
                return;
            } else if (type === 'remark' && this.currentBookRemark === '') {
                this.showSnackbar("error", "Please enter the remark");
                return;
            }
            const data = {
                review_id: id,
                review_value: value,
                criteria_id: criteria_id ? criteria_id : null,
                type: type, coi_id: this.subject, book_id: book_id
            }
            axios
                .post("BookReview/updateBookReview", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("success", "Updated successfully");
                        this.books = res.data.book_list;
                        // this.fetch();
                    } else if (res.data.flag == "NO") {
                        this.showSnackbar("error", res.data.snackbar)
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                })
                .finally(() => {
                    this.closeDialogs();
                });
        },
        submitFile(id, currentBookCover) {
            if (!this.currentBookCover) {
                this.showSnackbar("error", "Please select the file");
                return;
            }
            let formData = new FormData();
            formData.append("review_id", id);
            formData.append("front_cover", currentBookCover);
            formData.append("coi_id", this.subject);

            axios
                .post("BookReview/updateBookCover", formData)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("success", "Saved successfully");
                        this.CoverEdit = false;
                        this.fetch();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong");
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Somthing went wrong!!!");
                })
                .finally(() => {
                    this.CoverEdit = false;
                });

        },
        show_card() {
            if (this.add_book_review) {
                this.add_book_review = false;
                this.clearData();
            }
            else {
                this.add_book_review = true;
                this.clearData();
            }
        },
        fetch() {
            // this.show = true;
            const data = {
                coi_id: this.subject,
            };
            axios
                .post("BookReview/getSubjectsReviewDetails", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.review_criteria_details = res.data.review_criteria_details;
                        this.publisher_list = res.data.publisher_list;
                        this.books = res.data.book_list;
                        this.ay_display = res.data.ay;
                        this.standard_display = res.data.standard;
                        this.subject_display = res.data.subject;
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.subject_list = [];
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.learner_transport_fees_amount_id = ""
                    this.apply_payment_card = false
                });
        },
        getSubjects() {
            this.subject_list = []
            this.subject = ''
            const data = {
                ay: this.ay,
                standard: this.standard,
            };
            axios
                .post("BookReview/getSubjects", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.subject_list = res.data.courses_list;
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.subject_list = [];
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                    this.learner_transport_fees_amount_id = ""
                    this.apply_payment_card = false
                });
        },
        getStandard() {
            this.standard_list = []
            this.standard = ''
            const data = {
                ay: this.ay,

            };
            axios
                .post("BookReview/teacherBookReviewAy", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.standard_list = res.data.standard_list
                        this.overlay = false;
                    } else if (res.data.flag == "No") {
                        this.standard_list = [];
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                        this.overlay = false;
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;

                });
        },
        closeDialogs() {
            this.CommonEditDialog = false;
            this.NameEdit = false;
            this.PublisherEdit = false;
            this.AuthorEdit = false;
            this.PriceEdit = false;
            this.RemarkEdit = false;
            this.DateEdit = false;
            this.RecommondationEdit = false;
            this.CurrentUseEdit = false;
        },
        onLoad() {
            axios
                .post("/BookReview/teacherBookReview")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        (this.ay_list = res.data.ay_list),

                            this.overlay = false;
                    } else {
                        this.showSnackbar("#b71c1c", res.data.status_reason);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        fnExcelReport(id, name) {
            var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
            tab_text =
                tab_text +
                "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
            tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
            tab_text =
                tab_text +
                "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
            tab_text =
                tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
            tab_text =
                tab_text + "<table style='border-collapse:collapse;' border='1'>";
            var exportTable = $("#" + id).clone();
            exportTable.find("input").each(function (index, elem) {
                $(elem).remove();
            });
            exportTable.find("th, td").each(function () {
                $(this).css("border", "1px solid black");
            });
            tab_text = tab_text + exportTable.html();
            tab_text = tab_text + "</table></body></html>";
            var fileName =
                name + "_" + parseInt(Math.random() * 10000000000) + ".xls";
            const blob = new Blob([tab_text], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            const filename = name + ".xls";

            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // For IE
                window.navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                // For modern browsers
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
            }
        },
    },
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    watch: {},
};
</script>

<style scoped>
.table-container {
    max-height: 600px;
    /* Set maximum height for vertical scrolling */
    overflow-y: scroll;
    /* Vertical scrolling */
    overflow-x: scroll;
    /* Horizontal scrolling */
    border: 1px solid #ddd;
    /* Optional border for the table container */
    margin: 20px 0;
    /* Adds spacing above and below the table */
}

.styled-table {
    width: 100%;
    /* Ensure the table spans the container width */
    border-collapse: collapse;
    /* Avoid extra space between cells */
    table-layout: auto;
    /* Fix column widths */
}

.styled-table th,
.styled-table td {
    padding: 12px 15px;
    /* Cell padding */
    text-align: center;
    /* Center-align text */
    border: 1px solid #ddd;
    /* Add border around cells */
    word-wrap: break-word;
    /* Allow text to wrap within cells */
}

.styled-table th {
    position: sticky;
    /* Make headers sticky */
    top: 0;
    /* Fix headers at the top of the container */
    z-index: 2;
    /* Keep headers above other table content */
    background-color: #f7a132;
    /* Background for headers */
    font-weight: bold;
    /* Bold text for headers */
}

.styled-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
    /* Alternate row colors for better readability */
}


.action-icons,
.status-icons {
    display: flex;
    justify-content: center;
    gap: 10px;
}

.edit-btn,
.delete-btn {
    background-color: transparent;
    border: none;
    cursor: pointer;
}

.cover-cell {
    display: flex;
    align-items: center;
    gap: 10px;
}

.cover-image {
    width: 50px;
    height: auto;
}

.input-text {
    width: 100%;
    padding: 8px;
    border-radius: 8px;
    border: 1px solid #ccc;
    font-size: 14px;
    outline: none;
    transition: border 0.3s;
}

.input-text.dense {
    padding: 4px;
    font-size: 13px;
}

.input-text:focus {
    border-color: #007BFF;
    box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.input-text.round {
    border-radius: 20px;
}

.simple-table th {
    font-size: 15px;
    text-align: center;
}

.simple-table tr {
    background-color: #eceff1;
}

.simple-table td,
.simple-table th {
    border: 1px solid black;
}

.simple-table {
    width: 40%;
    margin: auto;
    text-align: center;
}
</style>